/* eslint-disable yoda */
import {createSelector,} from 'reselect';
import {createFeatureSelectionSelector} from '@mapsight/core/lib/feature-selections/selectors';
import {findFeatureInFeatureSourcesById} from '@mapsight/core/lib/feature-sources/selectors';
import {FEATURE_SELECTIONS, FEATURE_SOURCES} from '@mapsight/ui/src/js/config/constants/controllers';
import {FEATURE_SELECTION_PRESELECT, FEATURE_SELECTION_SELECT} from '@mapsight/ui/src/js/config/feature/selections';

import {STADE} from './controller';


export const navOpenSelector = createSelector(
	state => state[STADE].navigation,
	/**
	 * @param {object} _
	 * @returns {boolean}
	 */
	_ => !!_.open
);

export const languageOpenSelector = createSelector(
	state => state[STADE].language,
	/**
	 * @param {object} _
	 * @returns {boolean}
	 */
	_ => !!_.open
);

/** @param {import('./controller').RootState} state */
export function audioplayerSelector(state) {
	return state[STADE].audioplayer;
}

export const audioplayerStateSelector = createSelector(
	audioplayerSelector,
	(ap) => ap.state,
);

export const featureSelectionSelector = state => state[FEATURE_SELECTIONS][FEATURE_SELECTION_SELECT];

export const featureSelectPreselectSelector = createSelector(
	(state) => state[FEATURE_SOURCES],
	createFeatureSelectionSelector(FEATURE_SELECTIONS, FEATURE_SELECTION_SELECT),
	createFeatureSelectionSelector(FEATURE_SELECTIONS, FEATURE_SELECTION_PRESELECT),
	/** @returns {null | import('../types').Feature} */
	(
		sources,
		{features: selectIds},
		{features: preselectIds},
	) => {
		const featId = (() => {
			if (Array.isArray(selectIds) && 0 < selectIds.length) {
				return /** @type {string} */(selectIds[0]);
			}
			if (Array.isArray(preselectIds) && 0 < preselectIds.length) {
				return /** @type {string} */(preselectIds[0]);
			}
			return null;
		})();
		return findFeatureInFeatureSourcesById(sources, featId);
	}
);

/**
 * @param {string} appUri
 * @param {string} poiId
 */
 export const createHeartSelector = (appUri, poiId) =>
 /** @param {import('./controller').RootState} state */
	state => (state[STADE].hearts && state[STADE].hearts[appUri] && state[STADE].hearts[appUri][poiId] ?
		state[STADE].hearts[appUri][poiId] :
		{heart: false});
